document.addEventListener("DOMContentLoaded", async function () {

    checkDiscountOnLoad();
  
    const discountForm = document.getElementById("apply_discount");
    const discountInput = document.getElementById("discount-code");
    const discountMessage = document.getElementById("discount-message");

  
  $(document).on('click','.cart_discount_add',function(){
      var height_body = $('.discount_input_grid').height();
      // $(this).addClass('hide');
      $('.cart_discount_cancel').show();
      $('.discount_inputs_body').css('height',height_body+25+"px");
      $('.discount_inputs_body').addClass('active_input');
      discountMessage.textContent = "";
  })
  $(document).on('click','.cart_discount_cancel', function(){
      $(this).hide();
      $('.cart_discount_add').removeClass('hide');
      $('.discount_inputs_body').css('height', 0);
      $('.discount_inputs_body').removeClass('active_input');
      discountMessage.textContent = "";
  })

  
  
  // Function to check discount and update cart on page load
  async function checkDiscountOnLoad() {
    try {
      // Use cache: "no-store" only if necessary, default is fine for most cases
      const response = await fetch("/cart.js");
      const cart = await response.json();
  
      if (cart.cart_level_discount_applications?.length > 0) {
        const appliedDiscount = cart.cart_level_discount_applications[0].title;
  
        discountInput.value = appliedDiscount;
        discountMessage.textContent = `Discount applied: ${appliedDiscount}`;
        discountMessage.style.color = "green";
        $('.discount_code').removeClass('hide');
      }
  
      updateCart(cart); // Avoid doing unnecessary DOM or network work in this function
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  }


  async function removeDiscountAjax(discountToRemove) {
    try {

      let loader = document.querySelector(".cart-total-loader");
      let cartItemsParent = $('.w-commerce-commercecartformwrapper.cart_drawer_items_wrapper');

      if(loader){
        cartItemsParent.addClass('show-loader');
        loader.classList.remove("hide");
      }

      // 1) Get current cart
      const res = await fetch('/cart.js');
      const cart = await res.json();

      // 2) Collect discount codes (only manual/discount_code type)
      const codes = [];

      if (Array.isArray(cart.cart_level_discount_applications)) {
        for (const app of cart.cart_level_discount_applications) {
          if (app?.type === 'discount_code' && app.title) codes.push(app.title);
        }
      }

      for (const item of cart.items || []) {
        for (const alloc of item.line_level_discount_allocations || []) {
          const dapp = alloc.discount_application;
          if (dapp?.type === 'discount_code' && dapp.title) codes.push(dapp.title);
        }
      }

      // 3) Deduplicate and remove requested code
      const uniqueCodes = [...new Set(codes.map(c => c.trim()))];
      const remaining = uniqueCodes.filter(
        c => c.toLowerCase() !== discountToRemove.toLowerCase()
      );

      // 4) Clear existing discounts
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      });

      // 5) Reapply remaining (if any)
      if (remaining.length > 0) {
        const discountCodes = remaining.map(c => encodeURIComponent(c)).join(',');
        await fetch('/discount/' + discountCodes, {
          method: 'GET',
          credentials: 'same-origin',
          redirect: 'follow'
        });
      }

      const res1 = await fetch("/?section_id=cart-drawer-pdp");
      const text1 = await res1.text();
      const html1 = document.createElement("div");
      html1.innerHTML = text1;
      const newBox1 = html1.querySelector(".cart-wrapper").innerHTML;
      document.querySelector(".cart-wrapper").innerHTML = newBox1;

      /* updateCart(cart); // your existing UI update function
      discountMessage.textContent = "";
      discountInput.value = ""; */

      if(loader){
        cartItemsParent.removeClass('show-loader');
        loader.classList.add("hide");
      }

    } catch (err) {
      console.error('Error removing discount:', err);
      throw err;
    }
  }

  $(document).on('click', '.add-to-cart-button', function () {
    const $button = $(this); // store reference to 'this' button
    const loading_text = $button.attr('data-loading-text');
    const original_text = $button.attr('data-val');
  
    if (loading_text && loading_text !== 'undefined') {
      $button.val(loading_text);
    }

    checkDiscountOnLoad();
  
    setTimeout(function () {
      if (original_text && original_text !== 'undefined') {
        console.log(original_text);
        $button.val(original_text); // use stored reference
      }
    }, 1000);
  
  });


  $(document).on('click', '.apply_discount', async function (e) { 
  
      e.preventDefault(); 
  
      let discountvalue = document.getElementById("discount-code").value.trim();
      let  discountMessage = document.getElementById("discount-message");
      let loader = document.querySelector(".cart-total-loader");
      let cartItemsParent = $('.w-commerce-commercecartformwrapper.cart_drawer_items_wrapper');

       // const dibHeight = $('.discount_inputs_body').height();
  
      if (discountvalue === "") {
          discountMessage.textContent = "Please enter a discount code.";
          discountMessage.style.color = "red";
          if ($(window).width() <= 480) {
            $('.discount_inputs_body').css('height','74px');
          }
          return;
      }
      
      if(loader){
        cartItemsParent.addClass('show-loader');
        loader.classList.remove("hide");
      }
  
      try {

        let applied_discounts = []; 

        $('.discountCodes .discountRow').each(function() {
          let code = $(this).find('.discount_code-new').text().trim(); 
          if (code) { 
            code = code.toLowerCase(); 
            if (!applied_discounts.includes(code)) {
              applied_discounts.push(code); 
            } 
          } 
        });

        let appliedDiscounts = applied_discounts;

        if (appliedDiscounts.includes(discountvalue.toLowerCase())) {
          discountMessage.textContent = "Already applied!";
          discountMessage.style.color = "orange";
          // updateCart(cart);
          if ($(window).width() <= 480) {
            $('.discount_inputs_body').css('height','74px');
          }
          if(loader){
            cartItemsParent.removeClass('show-loader');
            loader.classList.add("hide");
          }
          return;
        }

        const endpoint = "https://scripts.lifely.network/cloudflare/worker/cushie-discount-validator/discount-api.php";
        const response = await fetch(endpoint);
        if (!response.ok) throw new Error(`Network error: ${response.status}`);
        const data = await response.json();

        if(!data.success == true && !Array.isArray(data.discounts)){
          console.log('Discounts are not fetched');
          if(loader){
            cartItemsParent.removeClass('show-loader');
            loader.classList.add("hide");
          }
          return;
        }

        let matchedDiscount = [];

        for (let i = 0; i < data.discounts.length; i++) {
          let discount_arr = data.discounts[i];
          if(discount_arr.status == 'ACTIVE'){
            if (discount_arr.codes && Array.isArray(discount_arr.codes)) {
              for (let j = 0; j < discount_arr.codes.length; j++) {
                matchedDiscount.push(discount_arr.codes[j].toLowerCase());
              }
            }
          }
        }

        let inputCode = discountvalue.toLowerCase(); // make sure discountValue is your field value

        if (!matchedDiscount.includes(inputCode)) {
          discountMessage.textContent = `${discountvalue} does not exist.`;
          discountMessage.style.color = "red";
          if(loader){
            cartItemsParent.removeClass('show-loader');
            loader.classList.add("hide");
          }
          return;
        }

        // let appliedDiscounts = cart.cart_level_discount_applications.map(discount => discount.title.toLowerCase());

        let discountResponse = await fetch("/discount/" + discountvalue, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        if (!discountResponse.ok) {
          throw new Error("Invalid discount code");
        }

        let cartResponse = await fetch("/cart.js");
        let cart = await cartResponse.json();

        let nowAppliedOrder = false;
        let nowAppliedItem = false;

        const displayedCodes = new Set();

        // --- Insert cart-level discounts ---
        if (cart.cart_level_discount_applications?.length) {
          for (let allocation of cart.cart_level_discount_applications) {
            const discount_code = allocation.title?.toLowerCase();
            let amount = allocation.total_allocated_amount;

            if(amount){
              amount = parseFloat(amount/100);
              amount = amount.toFixed(2);
            }

            if (!discount_code) continue;

            // First check if it's the code we just applied
            if (discount_code === inputCode) nowAppliedOrder = true;

            if (!displayedCodes.has(discount_code)) {
              displayedCodes.add(discount_code);
            }

          }
        }

        // --- Insert item-level discounts ---
        if (cart.items?.length) {
          for (let item of cart.items) {
            if (item.line_level_discount_allocations?.length) {
              for (let allocation of item.line_level_discount_allocations) {
                const title = allocation.discount_application?.title?.toLowerCase();
                let amount = allocation.discount_application?.total_allocated_amount;

                if(amount){
                  amount = parseFloat(amount/100);
                  amount = amount.toFixed(2);
                }

                if (title && !displayedCodes.has(title)) {
                  displayedCodes.add(title);
                  if (title === inputCode) nowAppliedItem = true;

                }
              }
            }
          }
        } 

        // --- Show discount messages ---
        if (nowAppliedOrder || nowAppliedItem) {
          discountMessage.textContent = `Discount applied`;
          discountMessage.style.color = "green";

          const res = await fetch("/?section_id=cart-drawer-pdp");
          const text = await res.text();
          const html = document.createElement("div");
          html.innerHTML = text;
          const newBox = html.querySelector(".cart-wrapper").innerHTML;
          document.querySelector(".cart-wrapper").innerHTML = newBox;

          if(loader){
            cartItemsParent.removeClass('show-loader');
            loader.classList.add("hide");
          }

        } else {
          discountMessage.textContent = `${discountvalue} couldn’t be used with your existing discount.`;
          discountMessage.style.color = "red";
        }

    }catch (error) {
      discountMessage.textContent = "Invalid discount code!";
      discountMessage.style.color = "red";
      $('.cart_discount_add').addClass('hide');
      if(loader){
        loader.classList.add("hide");
      }
    }
  }); 


  $(document).on('click', '#discount-all-price .discountCodes .discountRow .discount_code-new .removeCoupon', async function (e) {
    e.preventDefault();
    var discount_code = $(this).closest('.discount_code-new').attr('data-discount');
    removeDiscountAjax(discount_code);
  })
    
  function updateCart(cart) { 
    // Cache DOM elements once
    const subtotalDiv = document.querySelector(".cart_sub_total_price");
    const totaldiscount = document.querySelector(".total_discount_price");
    const totalDiv = document.getElementById("price-all-cart");
    const discountCodeEl = document.querySelector(".discount_code");
    const discountAddEl = document.querySelector(".cart_discount_add");

    
    let subtotal = cart.original_total_price / 100;
    let total = cart.total_price / 100;
    let discount = subtotal - total;
    
    const formatPrice = (price) => `$${price.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    
    if(cart.total_discount > 0)
    {
      var applydiscountcode = '';

      if(totaldiscount){
        totaldiscount.textContent = `-${formatPrice(discount)}`;
      }
      
      if(cart.cart_level_discount_applications.size > 0){
        
        applydiscountcode = `${cart.cart_level_discount_applications[0].title}x`;

      }else{
        let codes = [];
        let total_price_items = 0;

        cart.items.forEach(item => {
          item.line_level_discount_allocations.forEach(allocation => {
            const code = allocation.discount_application.title;

            // Add only if not already in codes
            if (!codes.includes(code)) {
              codes.push(code);
            }

            // Add original line price
            total_price_items += item.original_line_price;
          });
        });

        // Convert codes to comma-separated string (if needed)
        let codesString = codes.join(',');

        if(codesString){
          if(codesString.includes('Prime Big Deal Days')){
            applydiscountcode = `${codesString}`;
          }else{
            applydiscountcode = `${codesString}x`;
          }
          
        }

      }
        
      if(discountCodeEl){
        discountCodeEl.textContent = applydiscountcode;
      }
      if(discountAddEl){
        // discountAddEl.classList.add('hide');
      }
      if(totaldiscount){
        totaldiscount.classList.remove('hide');
      }
      
      if(discountCodeEl){
        discountCodeEl.classList.remove('hide');
      }
    
    }
    else{
      if(discountAddEl){
        discountAddEl.classList.remove('hide');
      }
      if(totaldiscount){
        totaldiscount.classList.add('hide');
        totaldiscount.textContent = formatPrice(cart.total_discount);
      }
      
      if(discountCodeEl){
        discountCodeEl.textContent = "";
        discountCodeEl.classList.add('hide');
      }
    }    
    
    subtotalDiv.textContent = formatPrice(subtotal);
    // discountDiv.textContent = discount > 0 ? `-${formatPrice(discount)}` : `$0.00`;
    totalDiv.textContent = formatPrice(total);
  }

  
});
